import { FETCH_ALL_DOCTOR_SUCCESS } from "constants/doctors.constants";
import {
  SELECT_DOCTOR_ID,
  LEAVE_START_DATE,
  LEAVE_END_DATE,
  SELECT_REMARK,
  FETCH_DOCTOR_LEAVES_SUCCESS,
  DOCTOR_LEAVE_ACTION_SUCCESS,
  DOCTOR_LEAVE_DIALOG_BOX_STATUS,
  DOCTOR_LEAVE_SET_DELETE_ID,
  DOCTOR_LEAVE_EDIT,
} from "../constants/doctorLeave.constants";
import moment from "moment";

const INIT_STATE = {
  doctors: [],
  newDoctorLeave: {
    id: null,
    doctor_id: "",
    start_date: "",
    end_date: "",
    remark: "",
  },
  doctor_leaves: [],
  dialogBoxStatus: false,
  delete_id: null,
  pagination: {
    current_page: 1,
    page_size: 0,
    total: 0,
    next_page: false,
    total_pages: 0,
  },
};

const doctorLeaveInfo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECT_DOCTOR_ID: {
      return {
        ...state,
        newDoctorLeave: {
          ...state.newDoctorLeave,
          doctor_id: action.doctor_id,
        },
      };
    }
    case LEAVE_START_DATE: {
      return {
        ...state,
        newDoctorLeave: {
          ...state.newDoctorLeave,
          start_date: action.start_date,
        },
      };
    }
    case LEAVE_END_DATE: {
      return {
        ...state,
        newDoctorLeave: {
          ...state.newDoctorLeave,
          end_date: action.end_date,
        },
      };
    }
    case SELECT_REMARK: {
      return {
        ...state,
        newDoctorLeave: {
          ...state.newDoctorLeave,
          remark: action.remark,
        },
      };
    }
    case FETCH_ALL_DOCTOR_SUCCESS: {
      return {
        ...state,
        doctors: action.payload.data,
      };
    }
    case FETCH_DOCTOR_LEAVES_SUCCESS: {
      const { current_page, page_size, total, next_page } = action.doctor_leaves.paginate;
      return {
        ...state,
        doctor_leaves: action.doctor_leaves.data,
        pagination: {
          ...state.pagination,
          current_page: current_page !== undefined ? parseInt(current_page) : 1,
          page_size: parseInt(page_size),
          total: parseInt(total),
          next_page: next_page,
          total_pages: Math.round(parseInt(total) / parseInt(page_size)),
        },
      };
    }
    case DOCTOR_LEAVE_ACTION_SUCCESS: {
      const { current_page, page_size, total, next_page } = action.doctor_leaves.paginate;
      return {
        ...state,
        doctor_leaves: action.doctor_leaves.data,
        newDoctorLeave: INIT_STATE.newDoctorLeave,
        pagination: {
          ...state.pagination,
          current_page: current_page !== undefined ? parseInt(current_page) : 1,
          page_size: parseInt(page_size),
          total: parseInt(total),
          next_page: next_page,
          total_pages: Math.round(parseInt(total) / parseInt(page_size)),
        },
      };
    }
    case DOCTOR_LEAVE_EDIT: {
      const id = action.doctor_leave_id;
      const filterData = state.doctor_leaves.filter(
        (doctor_leave) => doctor_leave.id === parseInt(id)
      )[0];
      moment.defaultFormat = "YYYY-MM-DDTHH:mm:ss";
      const { doctor_id, start_time_date, end_time_date, remark } = filterData;
      const newDoctorLeaveData = {
        id: id,
        doctor_id: doctor_id,
        start_date: moment(start_time_date, moment.defaultFormat).toDate(),
        end_date: moment(end_time_date, moment.defaultFormat).toDate(),
        remark: remark,
      };
      return {
        ...state,
        newDoctorLeave: newDoctorLeaveData,
      };
    }
    case DOCTOR_LEAVE_DIALOG_BOX_STATUS: {
      return {
        ...state,
        dialogBoxStatus: action.status,
      };
    }
    case DOCTOR_LEAVE_SET_DELETE_ID: {
      return {
        ...state,
        delete_id: action.delete_id,
      };
    }
    default:
      return state;
  }
};

export default doctorLeaveInfo;
